import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "../index.css"

import { Button, DropDownField, TextInputField } from "../../../helpers";

import { round } from "lodash";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Divider } from "primereact/divider"

import Loading from "../../../common/Loading";
import AddShippingAddress from "../../../common/AddShippingAddress";
import BillingAddressCards from "../../../common/BillingAddressCards";
import ShippingAddressCards from "../../../common/ShippingAddressCards"

import { addCompanyBranchShipAddrData } from "../../../services/api/companyBranchShipAddr";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { BUYERPO_QTY_TOLERANCE_PERCENTAGE } from "../../../constants";

import { checkPermissions, getBuyerProductSpecification, getMaterialMasterDetailsTooltip } from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const RaisePOModal = (props) =>{
    const { 
        materialDetails, 
        isLoadingVisible, 
        setIsLoadingVisible,
        isAllItemsPODone, 
        selectedBuyerBillAddrId, 
        setSelectedBuyerBillAddrId, 
        selectedBuyerShipAddrId, 
        setSelectedBuyerShipAddrId, 
        buyerShipAddrDetails, 
        buyerBillAddrDetails, 
        buyerQuote, 
        buyerPOItems, 
        raisedBuyerQuoteItems, 
        handleBuyerPOItemChange, 
        selectedBuyerQuoteItems, 
        handleCheckBoxClick, 
        handleSelectBuyerQuoteItems,
        materialBrands,
        materialUOMs,
        initialRaisedBuyerQuoteItems,
        buyerRateContracts,
        setraisedBuyerQuoteItems,
        setBuyerShipAddressDetails,
        stateList,
        countriesData,
        pinCodes,
        userDetails
    } = props

    const [visibleAddNewShippingAddr, setVisibleAddNewShippingAddr] = useState(false)

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)
   
    const dispatch = useDispatch()

    useEffect(() => {
        const relatedBuyerBillAddr = buyerBillAddrDetails?.find(eachBillAddr => eachBillAddr?.billAddrId === selectedBuyerBillAddrId)
        const relatedBuyerShipAddr = buyerShipAddrDetails?.find(eachShipAddr => eachShipAddr?.shipAddrId === selectedBuyerShipAddrId)
        setSelectedBuyerBillAddrId(relatedBuyerBillAddr?.billAddrId)
        setSelectedBuyerShipAddrId(relatedBuyerShipAddr?.shipAddrId)
    }, [buyerBillAddrDetails, buyerShipAddrDetails])

    const handleChange = (e, buyerQuoteItemId, availableQty) => {
        if (parseInt(e.target.value) > availableQty){
            handleBuyerPOItemChange(buyerQuoteItemId, e.target.name, availableQty)
            dispatch(raiseToast({severity:'error', detail:`Available Qty : ${availableQty} Only`, life: 3000}))
        }else {
            handleBuyerPOItemChange(buyerQuoteItemId, e.target.name, e.target.value )
        }
    }

    const handleSelectAll = (e) => {
        handleCheckBoxClick(e)
    }

    const handleChecked = (buyerQuoteItemId) => {
        handleSelectBuyerQuoteItems(buyerQuoteItemId)
    }

    const handleShippingAddress = (shipAddrId) => {
        if (shipAddrId){
            setSelectedBuyerShipAddrId(shipAddrId)
        }else {
            setSelectedBuyerShipAddrId(null)
        }
    }

    const handleBillingAddress = (billAddrId) => {
        if (billAddrId){
            setSelectedBuyerBillAddrId(billAddrId)
        }else {
            setSelectedBuyerBillAddrId(null)
        }
    }

    const handleEditClick = () => {
        const updatedBuyerQuoteItems = raisedBuyerQuoteItems?.map(eachBuyerQuoteItem => ({...eachBuyerQuoteItem, isEditable: true}))
        setraisedBuyerQuoteItems(updatedBuyerQuoteItems)
        
    }

    const handleSaveClick = () => {
        if (window.confirm("Do you want to save the changes...?")){ // are you sure you want to modify qty multipler as it impacts the invoice qty display
            const updatedBuyerQuoteItems = raisedBuyerQuoteItems?.map(eachBuyerQuoteItem => ({...eachBuyerQuoteItem, isEditable: false}))
            setraisedBuyerQuoteItems(updatedBuyerQuoteItems)
        }
        
    }

    const handleDiscard = () => {
        if (window.confirm("Do you want to discard the changes...?")){
            setraisedBuyerQuoteItems(initialRaisedBuyerQuoteItems)
        }
    }


    const handleAddShippingAddressSubmit = async (formResult) => {
        if (window.confirm("Do you want to add shipping address?")) {
            const { companyId, branchId } = buyerQuote

            if (formResult) {
                setIsLoadingVisible(true)
                const { address, city, pinCode, stateId, countryId } = formResult
               
                const data = { companyId, branchId, city, pinCode, stateId, shipAddr: address, countryId }
                const response = await addCompanyBranchShipAddrData({ ...data })

                if (response.failure) return dispatch(raiseToast({ severity: 'error', summary: 'Add Shipping Address', detail: response.data.error, life: 3000 }))

                const newShippingAddress = {
                    shipAddrId: response.data.shipAddrId,
                    shipAddr: response.data.shipAddr,
                    city: response.data.city,
                    stateId: response.data.stateId,
                    countryId: response.data.countryId,
                    pinCode: response.data.pinCode
                }

                const newShippAddrList = [...buyerShipAddrDetails, newShippingAddress]

                setSelectedBuyerShipAddrId(newShippingAddress.shipAddrId)
                setBuyerShipAddressDetails(newShippAddrList)
                setVisibleAddNewShippingAddr(false)

                setIsLoadingVisible(false)
            }
        }
    }

    const canProductDetailsEditable = raisedBuyerQuoteItems?.some(eachBuyerQuoteItem => eachBuyerQuoteItem?.isEditable)

    const {isPermitted: canAddNewShipAddress} = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [208] })

    return(
        <div>
            <div className="p-card mt-2 mb-2 py-2">
                <div className="flex flex-row justify-content-between align-items-center">
                    <h5 className="my-2 text-600">
                        <Checkbox inputId="selectAllProduct" disabled={isAllItemsPODone} checked={selectedBuyerQuoteItems?.length === raisedBuyerQuoteItems?.length} onChange={e => handleSelectAll(e)}/>
                        <label htmlFor="selectAllProduct" className="ml-2">Select All Products</label>
                    </h5>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        {
                            canProductDetailsEditable ? (
                                <>
                                    <Button className="small-btn ml-3 discard-btn" label="Discard" style={{fontSize : "12px"}} onClick={() => handleDiscard()}/>
                                    <Button className="small-btn ml-3" label="Save" style={{fontSize: "12px", border : 0, backgroundColor: "purple"}} onClick={() =>handleSaveClick()}/>
                                </>
                            ) : (
                                <Button label="Edit" className="small-btn ml-3" style={{fontSize: "12px"}} onClick={() => handleEditClick()}/>
                            )
                        }
                    </div>
                </div>
                <div className="flex flex-column ml-1">
                    <div className="product-container">
                        {
                            raisedBuyerQuoteItems?.map((eachBuyerQuoteItem, index) => {
                                let totalCompletedQty = 0
                                buyerPOItems?.map(eachBuyerPOItem => {
                                    if (eachBuyerPOItem?.buyerQuoteItemId === eachBuyerQuoteItem?.buyerQuoteItemId){ //need to discuss
                                        totalCompletedQty += eachBuyerPOItem?.bPOQty
                                    }
                                })

                                let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerQuoteItem?.materialId)
                                const relatedBrand = materialBrands?.find(eachBrand => eachBrand?.brandId === relatedMaterial?.brandId)
                                let toleranceQty = eachBuyerQuoteItem?.totReqQty * BUYERPO_QTY_TOLERANCE_PERCENTAGE * 0.01
                                let availableQty = (eachBuyerQuoteItem?.totReqQty - totalCompletedQty) < 0 ? 0 : eachBuyerQuoteItem?.totReqQty - totalCompletedQty
                                let materialValues = getMaterialMasterDetailsTooltip(relatedMaterial) 
                                let relatedInitialBuyerQuoteItem = initialRaisedBuyerQuoteItems?.find(eachInitialBuyerQuoteItem => eachInitialBuyerQuoteItem?.buyerReqItemId === eachBuyerQuoteItem?.buyerReqItemId)
                                let relatedBuyerRateContract = buyerRateContracts?.find(eachBuyerRateContract => eachBuyerRateContract?.companyERPCodeMapId === eachBuyerQuoteItem?.companyERPCodeMapId && eachBuyerRateContract?.statusId === 1)

                                const buyerUnitPrice = round(eachBuyerQuoteItem?.bQuotUnitPrice / eachBuyerQuoteItem?.companyQtyMultiplier)
                                const buyerTotalPrice = round(buyerUnitPrice * eachBuyerQuoteItem?.bPOQty * eachBuyerQuoteItem?.companyQtyMultiplier)
                                let isActiveBuyerRateContractExists = relatedBuyerRateContract?.buyerRateContractId ? true : false

                                return (
                                    <div className="flex flex-row justify-content-between py-2 ml-2 mt-0" >
                                        <div className="flex flex-column">
                                            <div className="flex flex-row mt-2" style={{ width: "100%"}}>
                                                <div className="flex flex-row" style={{width: '34%'}}>
                                                    <Checkbox inputId="selectProduct" disabled={availableQty === 0} checked={selectedBuyerQuoteItems.includes(eachBuyerQuoteItem?.buyerQuoteItemId)} onChange={() => handleChecked(eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                    <div className="ml-2"> 
                                                        <span className="text-600 font-semibold">
                                                            {relatedMaterial?.companyProdName ? `${relatedMaterial?.companyProdName} | ` : `${relatedMaterial?.productName} | `}
                                                        </span>
                                                        <span className="text-xs">
                                                            {getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}
                                                        </span> 
                                                    </div>
                                                </div>
                                                {
                                                    index === 0 &&
                                                    <div className="flex flex-row justify-content-center ml-5" >
                                                        <span className="font-semibold">Client Documentation Details</span>
                                                    </div>
                                                }
                                            </div>
                                            <div className="flex flex-row mt-3" style={{width: "100%"}}>
                                                <div className="flex flex-column mt-1 mx-2" style={{ width: "4%"}}>
                                                    <TextInputField name="" labelText="Price" value={eachBuyerQuoteItem.bQuotUnitPrice} disabled />
                                                </div>
                                                {
                                                    pmCompanyConfig.isHSNVisible ?
                                                    <div className="flex flex-column mt-1 mx-1" style={{ width: "9%"}}>
                                                        <TextInputField name="bPOHSNCode" labelText="HSN (GSTRate %)" value={`${eachBuyerQuoteItem?.bQuotHSNCode}(${eachBuyerQuoteItem?.bQuoteGSTRate})`} disabled />
                                                    </div>
                                                    :
                                                    <div className="flex flex-column mt-1 mx-1" style={{ width: "6%"}}>
                                                        <TextInputField name="bPOGSTRate" labelText={`${pmCompanyConfig.GSTRateLabel} (%)`} value={`${eachBuyerQuoteItem?.bQuoteGSTRate}`} disabled />
                                                    </div>
                                                }
                                                <div className="flex flex-column mt-1 mx-1" style={{ width: "4%"}}>
                                                    <TextInputField name="UOM" labelText="UOM"  className="uom-label-text" disabled value={relatedMaterial?.UOM}/>{/* changes done as TextInputField*/}
                                                </div>
                                                <div className="flex flex-column mt-1 mx-1" style={{ width: "6%"}}>
                                                    <TextInputField name="" labelText="Avail. Qty" value={availableQty} disabled />
                                                </div>
                                                {/* <div className="flex flex-column mt-1 mx-3" style={{ width: "10%"}}>
                                                    <TextInputField name="" labelText={`Tolerance Qty (${BUYERPO_QTY_TOLERANCE_PERCENTAGE}%)`} value={toleranceQty} disabled />
                                                </div> */}
                                                <div className="flex flex-column mt-1 mx-1" style={{ width: "6%"}}>
                                                    <TextInputField name="bPOQty" labelText="Input Qty" disabled={availableQty === 0} value={eachBuyerQuoteItem?.bPOQty} keyfilter={"pnum"} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId, eachBuyerQuoteItem?.totReqQty - totalCompletedQty + toleranceQty)}/>
                                                </div>



                                                {/*  */}
                                                {/* <div className="flex flex-column mt-1 mx-1" style={{ width: "3%"}}>
                                                    <TextInputField name="companyERPUOM" labelText="C. UOM" disabled={availableQty === 0 || isActiveBuyerRateContractExists} value={eachBuyerQuoteItem?.companyERPUOM} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                </div> */}
                                                {/* <div className="flex"> */}
                                                    <Divider layout="vertical" type="solid" className="" style={{borderLeft: '1px solid  #808080', height: '100%'}}/>
                                                {/* </div> */}
                                                <div className="flex flex-column" style={{width: '65%'}}>
                                                    <div className="flex flex-row" style={{width: '100%'}}>
                                                        <Tooltip target={`.custom-tool-tip-${eachBuyerQuoteItem?.buyerReqItemId}`} position="right" autoHide>
                                                            <p>Please Enter Qty Multiplier so that Client Qty equals to PO Qty.</p>
                                                        </Tooltip>
                                                        <div className={`flex flex-column mt-1 mx-1 custom-tool-tip-${eachBuyerQuoteItem?.buyerReqItemId}`} style={{ width: "8%"}}>
                                                            <TextInputField name="companyQtyMultiplier" labelText="Qty Multi." disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyQtyMultiplier} tooltip={"Please Enter Qty so that Client Qty equals to PO Qty."}  keyfilter={"pnum"} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                        </div>
                                                        <div className="flex flex-column mt-1 mx-1" style={{width: '40%'}}>
                                                            <TextInputField className="pl-2" name="companyProdName" labelText="Product Name" disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyProdName} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)} maxLength={255}/>
                                                        </div>
                                                        {/* <div className="flex flex-column mt-1 mx-1" style={{ width: "15%"}}>
                                                            <TextInputField name="companyProdSpec" labelText="C. ProdSpec" disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyProdSpec} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                        </div> */}
                                                        <div className="flex flex-column mt-1 mx-1" style={{ width: "12%"}}>
                                                            <TextInputField name="companyERPCode" labelText="ERP Code" disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyERPCode} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                        </div>
                                                        <div className={`flex flex-column mt-1 mx-1`} style={{ width: "8%"}}>
                                                            <TextInputField name="companyUOMQty" labelText="UOM Qty" value={eachBuyerQuoteItem?.bPOQty * eachBuyerQuoteItem?.companyQtyMultiplier} disabled/>
                                                        </div>
                                                        <div className="flex flex-column mt-1 mx-1" style={{ width: "8%"}}>
                                                            <DropDownField name="companyERPUOMId" labelText="UOM" options={materialUOMs} optionValue="materialUOMId" optionLabel="UOM" disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyERPUOMId} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)}/>
                                                        </div>
                                                        <div className={`flex flex-column mt-1 mx-1`} style={{ width: "8%"}}>
                                                            <TextInputField name="companyPrice" labelText="Unit Price" value={buyerUnitPrice} disabled/>
                                                        </div>
                                                        <div className={`flex flex-column mt-1 mx-1`} style={{ width: "8%"}}>
                                                            <TextInputField name="companyTotalPrice" labelText="Total Amt" value={buyerTotalPrice} disabled/>
                                                        </div>
                                                        {
                                                            isActiveBuyerRateContractExists ?
                                                            <>
                                                                <div className={`flex flex-column mt-4 mx-1 custom-tool-tip-${eachBuyerQuoteItem?.materialId}`} style={{ width: "2%"}}>
                                                                    <i className="pi pi-info-circle quote-gst-icon ml-1"></i>
                                                                </div>
                                                                <Tooltip target={`.custom-tool-tip-${eachBuyerQuoteItem?.materialId}`} position="top" autoHide>
                                                                    <p className="m-0"> Cannot be edited as there's an active RateContract on this item. Please edit on rate contract, or use replace prod on invoice.</p>
                                                                </Tooltip>
                                                            </> : 
                                                            <>
                                                                <div className={`flex flex-column mt-4 mx-1 custom-tool-tip-${eachBuyerQuoteItem?.materialId}`} style={{ width: "2%"}}>
                                                                    {/* <i className="pi pi-info-circle quote-gst-icon ml-1"></i> */}
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                    <div className="flex flex-row mt-2" style={{width: '100%'}}>
                                                        <div className="flex flex-column mt-1 mx-1" style={{ width: "96%"}}>
                                                            <TextInputField name="companyProdSpec" labelText="Product Specifications" disabled={availableQty === 0 || isActiveBuyerRateContractExists || !eachBuyerQuoteItem?.isEditable} value={eachBuyerQuoteItem?.companyProdSpec} onChange={e => handleChange(e, eachBuyerQuoteItem.buyerQuoteItemId)} maxLength={300}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*  */}
                                        </div>
                                    </div>
                                )}
                            )
                        }

                        <p>Logistics: </p>
                        <div className="flex flex-row">
                            <div className="flex flex-column mt-1 mx-1" style={{ width: "10%"}}>
                                <TextInputField name="bQuoteLogisticsOption" labelText="logistics Option" value={buyerQuote.bQuoteLogisticsOption} disabled />
                            </div>
                            <div className="flex flex-column mt-1 mx-1" style={{ width: "10%"}}>
                                <TextInputField name="bQuotLogisticsBeforeTax" labelText="Log. charge" value={buyerQuote.bQuotLogisticsBeforeTax} disabled />
                            </div>
                            <div className="flex flex-column mt-1 mx-1" style={{ width: "10%"}}>
                                <TextInputField name="bQuotLogisticsGSTRate" labelText="Tax Rate" value={buyerQuote.bQuotLogisticsGSTRate} disabled />
                            </div>
                            <div className="flex flex-column mt-1 mx-1" style={{ width: "10%"}}>
                                <TextInputField name="bQuotLogisticsWithTax" labelText="Total Logistic" value={buyerQuote.bQuotLogisticsWithTax} disabled />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Loading visible={isLoadingVisible}/>

            <div className="p-card">
                <h5 className="text-600 mt-1">Billing Address</h5>
                <BillingAddressCards billingAddresses={buyerBillAddrDetails} selectedAddressId={selectedBuyerBillAddrId} handleBillingAddress={handleBillingAddress}/>
                <div className="hr-line"></div>
                <h5 className="text-600 mt-2">Shipping Address</h5>
                <ShippingAddressCards 
                    shippingAddresses={buyerShipAddrDetails} 
                    selectedAddressId={selectedBuyerShipAddrId} 
                    handleShippingAddress={handleShippingAddress}
                    showAddShipAddr={selectedBuyerShipAddrId === null && buyerShipAddrDetails.length > 0 && canAddNewShipAddress}
                    setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr}
                />
            </div>
            <Dialog header="Add New Shipping Address" visible={visibleAddNewShippingAddr} onHide={() => setVisibleAddNewShippingAddr(false)}>
                <AddShippingAddress stateList={stateList} setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr} setShippingAddressesList={setBuyerShipAddressDetails} shippingAddressesList={buyerShipAddrDetails} handleSubmit={handleAddShippingAddressSubmit} countriesData={countriesData} pinCodesData={pinCodes} />
            </Dialog>
        </div>
    )
}

export default RaisePOModal;